import {
  checkAllowShowConsent, getApiOrigin, getCdnOrigin, isDevOrigin,
} from '~/src/helpers/common.helpers';

function appendScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.onload = (): void => resolve();
    script.onerror = (): void => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
}

function appendInlineScript(code: string): void {
  const script = document.createElement('script');
  script.textContent = code;
  document.head.appendChild(script);
}

function getProductName(): string {
  if (origin.includes('sso.omo-tech')) {
    return 'OMO Grow Management Platform';
  }

  if (origin.includes('sso.wavesend')) {
    return 'Вейвсенд';
  }

  return 'Pushwoosh';
}

function getProductIcons(): string {
  if (origin.includes('sso.omo-tech')) {
    return `
      <link rel="shortcut icon" href="/static/favicon-omo.png">
      <link rel="apple-touch-icon" sizes="180x180" href="/static/favicon-omo.png" />
      <link rel="mask-icon" href="/static/safari-pinned-tab-omo.svg" color="#0F4DBA" />
    `;
  }

  if (origin.includes('sso.wavesend')) {
    return `
      <link rel="shortcut icon" href="/static/favicon-ws.svg">
      <link rel="apple-touch-icon" sizes="180x180" href="/static/favicon-ws.svg" />
      <link rel="mask-icon" href="/static/safari-pinned-tab-ws.svg" color="#0F4DBA" />
    `;
  }

  return `
    <link rel="apple-touch-icon" sizes="180x180" href="/static/apple-touch-icon-pw.png" />
    <link rel="icon" type="image/png" sizes="32x32" href="/static/favicon-32x32.png" />
    <link rel="icon" type="image/png" sizes="16x16" href="/static/favicon-16x16.png" />
    <link rel="manifest" href="/static/site.webmanifest" />
    <link rel="mask-icon" href="/static/safari-pinned-tab-pw.svg" color="#0077ff" />
  `;
}

export async function updateHTML(): Promise<void> {
  const htmlCollectionTitle = document.getElementsByTagName('title');
  const [title] = Array.from(htmlCollectionTitle);
  if (title && title.innerText) {
    title.innerText = getProductName();
  }

  const htmlCollectionHead = document.getElementsByTagName('head');
  const [head] = Array.from(htmlCollectionHead);
  if (head && head.innerText) {
    head.innerHTML += getProductIcons();
  }

  let script = '';
  const promises: Array<Promise<unknown>> = [];

  // Installer stands have no CDN host at all — nothing serves cdn.<stand> — so
  // these scripts always 404 there. Loading them anyway is not merely
  // useless: Promise.all below rejects, the rejection is reported to the
  // production Sentry project, and appendInlineScript never runs. Consent
  // tooling and action tracking have no purpose on a throwaway stand, so skip
  // both the scripts and their init snippets.
  const isDev = isDevOrigin();

  if (!isDev && checkAllowShowConsent()) {
    script += 'window.__Consent.init();';
    promises.push(appendScript(getCdnOrigin('/frontend/shared-scripts/consent.js')));
  }

  if (!isDev) {
    promises.push(appendScript(getCdnOrigin('/frontend/shared-scripts/user-actions.js')));

    script += `
    window.__UserActions.init({
      beaconUrl: '${getApiOrigin('user-action')}/api/v1/statistics/user-action/collect',
    });`;
  }

  await Promise.all(promises);
  appendInlineScript(script);
}
